'use client'

import { useState } from "react"
import MainScene from "../MainScene/MainScene"
import styles from "./MainSceneWithWrapper.module.scss"

const MainSceneWithWrapper = ({top, zInx, bottomBlur=false} : {top?: string | number, zInx?: number, bottomBlur?: boolean}) => {
    const [hoverItem, setHoverItem] = useState<number>(0)

    return (
        <>
            <div className={styles.mobileMapMargin}></div>
            <div
                className={`${bottomBlur == true ? "bottomBlur" : ""} ${styles.wrapper}`}
                style={{
                    overflow: 'hidden',
                    height: 'max(90dvh, 500px)',
                    width: "100%",
                    left: 0,
                    display: "flex",
                    justifyContent: "flex-end",
                    position: 'absolute',
                    top: top || '0',
                    zIndex: zInx || 5
                }}
            >
                {/* !DEV */}
                {/* <FPSStats /> */}
                <MainScene
                    hoverItem={hoverItem}
                    setHoverItem={setHoverItem}
                    styles={{ height: '100vh', width: '100%', filter: 'saturate(70%)' }}
                />
            </div>
        </>
    )
}

export default MainSceneWithWrapper
